import { EMPTY_SYMBOL_24, ISDSIcon } from "@sznds/icons";
import { ISDSIconMulti } from "~/interfaces";
import { node } from "~/util/dom";

interface SDSIconOptions extends HTMLMapyIconElement {
	symbol: ISDSIcon | ISDSIconMulti;
}

export default function createSDSIcon({
	symbol = EMPTY_SYMBOL_24,
	className = "",
	...props
}: Partial<SDSIconOptions>): HTMLMapyIconElement {
	const icon = node("mapy-icon", {
		className,
		...props,
	});
	const paths = (Array.isArray(symbol.d) ? symbol.d : [symbol.d]).map(points => {
		const path = document.createElement("path");

		path.setAttribute("d", points);

		return path;
	});

	icon.setAttribute("size", symbol.size.toString());
	icon.append(...paths);

	return icon;
}
